import React, { useState, useEffect, useContext, Fragment } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import ScorecardManagementTable from './ScorecardManagementTable';
import ScorecardPreviewContainer from './ScorecardPreviewContainer';
import Dialog from '@mui/material/Dialog';
import AddEditScorecardDetailsModal from './AddEditScorecardDetailsModal';
import { MsalContext } from '../Contexts/MsalContext';
import ScorecardFiltersViewModel from './Viewmodels/ScorecardFiltersViewModel';
import { APIContext } from '../Contexts/APIContext';
import ScorecardManagementTableRowViewModel from './Viewmodels/ScorecardManagementTableRowViewModel';
import ScorecardManagementFilters from './Scorecard Management Filters/ScorecardManagementFilters';

export default function ScorecardManagementContainer() {
    const { msalFetch } = useContext(MsalContext);
    const { post } = useContext(APIContext);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<ScorecardManagementTableRowViewModel[]>([]);
    const [count, setCount] = useState(0)
    const [scorecardId, setScorecardId] = useState(0);
    const [saving, setSaving] = useState(false);
    const [refreshTable, setRefreshTable] = useState(false);
    const [openAddScorecard, setOpenAddScorecard] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [filters, setFilters] = useState<ScorecardFiltersViewModel>(new ScorecardFiltersViewModel())

    useEffect(() => {
        msalFetch('api/User/IsAdmin')
            .then(resp => resp.json())
            .then(data => {
                setIsAdmin(data);
            });
    }, []);

    useEffect(() => {
        getData();
    }, [filters.page, filters.rowsPerPage, filters.order, filters.orderBy, refreshTable]);

    const getData = () => {
        setLoading(true);
        post('ScorecardManagement', `GetScorecardManagementTable`, (filters), (data) => {
            setRows(data.rows);
            setCount(data.count);
            setLoading(false);
        });
    }

    const toggleAddScorecard = () => {
        setSaving(true);
        setOpenAddScorecard((prev) => !prev);
    }

    const closeAddScorecard = (refresh: boolean, templateId?: number) => {
        setSaving(false);
        if (refresh) setRefreshTable((prev) => !prev);
        setOpenAddScorecard(false);
        if (templateId) setScorecardId(templateId);
    }

    const closePreview = () => setScorecardId(0);

    const changeFilter = (filterName: keyof ScorecardFiltersViewModel, newValue: any) => {
        setFilters(prev => ({
            ...prev,
            [filterName]: newValue
        }))
    }

    return (isAdmin ?
        <Grid container spacing={1}>
            <Dialog
                open={scorecardId !== 0}
                onClose={() => setScorecardId(0)}
                fullScreen
            >
                <ScorecardPreviewContainer id={scorecardId} close={closePreview} />
            </Dialog>
            <Grid size={12}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid>
                        <Typography variant="h6">Scorecard Management</Typography>
                    </Grid>
                    <Grid>
                        <Grid container spacing={2} alignItems="center">
                            <ScorecardManagementFilters filters={filters} changeFilter={changeFilter} />
                            <Grid>
                                <Button variant='contained' color='primary' onClick={getData}>Search</Button>
                            </Grid>
                            <Grid>
                                <Button startIcon={<AddIcon />} onClick={toggleAddScorecard} fullWidth disabled={saving} color="primary" variant="contained">Add New Scorecard</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12}>
                <ScorecardManagementTable
                    rows={rows}
                    count={count}
                    filters={filters}
                    changeFilter={changeFilter}
                    refresh={refreshTable}
                    setScorecardId={setScorecardId}
                    loading={loading}
                    getData={getData} />
            </Grid>
            <AddEditScorecardDetailsModal open={openAddScorecard} onClose={closeAddScorecard} editId={0} />
        </Grid>
        :
        <Fragment />
    );
}